import React from 'react';
import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import {IListConfigDatetimeColumn} from '@src/@interfaces/components/List/IListConfigDatetimeColumn';
import {DateTime} from '@src/@types/DateTime';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import MomentDate from '@src/components/MomentDate/MomentDate';

export default class DatetimeColumn<
        Model extends IEmptyModel = IEmptyModel
> extends ListColumn<ListConfigNamedColumn<IListConfigDatetimeColumn>, Model> {
    protected get value(): any {
        const datetime = super.value as DateTime | null;
        if (!datetime) {
            return null;
        }

        return <MomentDate date={datetime} format={this.config.format ?? 'LLL'} withWrapperTag="div"/>;
    }
}
